
import { DisplayCompType } from '../../_Common/Const/BusinessConfigs';
import { ValueType } from '../../../../Utils/Formatters/FormatterTypes';
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';
import { TEDBOAktivitetStatistikStatusEnum } from '../../../../globalQueryTypes';
import EDTooltip from '../../../../BaseComponents/Tooltip/EDTooltip';

interface IProps {
  value: ValueType;
  displayValue: string;
}

const DisplayStatistikStatus: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  return StatistikStatusIcon(props.value as TEDBOAktivitetStatistikStatusEnum);
};

const StatistikStatusIcon = (
  StatistikStatus: TEDBOAktivitetStatistikStatusEnum
) => {
  switch (StatistikStatus) {
    case TEDBOAktivitetStatistikStatusEnum.DET_AR_MINDRE_AN_7_DAGAR_KVAR_ATT_RAPPORTERA_STATISTIK_PA_AKTIVITETEN:
      return (
        <EDTooltip title="Det är mindre än 7 dagar kvar att rapportera statistik på aktiviteten">
          <span>
            <EDIcon iconType="timer_outlined" />
          </span>
        </EDTooltip>
      );
    case TEDBOAktivitetStatistikStatusEnum.STATISTIK_RAPPORTERAD:
      return (
        <EDTooltip title="Statistik rapporterad">
          <span>
            <EDIcon iconType="check" />
          </span>
        </EDTooltip>
      );
    case TEDBOAktivitetStatistikStatusEnum.STATISTIK_EXPORTERAD:
      return (
        <EDTooltip title="Statistik exporterad">
          <span>
            <EDIcon iconType="export" />
          </span>
        </EDTooltip>
      );
    case TEDBOAktivitetStatistikStatusEnum.MISSLYCKAD_EXPORT__KONTROLLERA_BOKNINGEN:
      return (
        <EDTooltip title="Misslyckad export kontrollera bokningen">
          <span>
            <EDIcon iconType="export_failed" />
          </span>
        </EDTooltip>
      );
    case TEDBOAktivitetStatistikStatusEnum.SISTA_RAPPORTERINGSDAG_HAR_PASSERAT:
      return (
        <EDTooltip title="Sista rapporteringsdag har passerat">
          <span>
            <EDIcon iconType="lock" />
          </span>
        </EDTooltip>
      );
    default:
      return <></>;
  }
};
const displayStatistikStatus: DisplayCompType = DisplayStatistikStatus;

export default displayStatistikStatus;
